import crypto from 'crypto';

export default class Payeer {
    constructor(shopId, key, curr) {
        this.shopId = shopId;
        this.key = key;
        this.curr = curr;
    }
    setOrder(orderId) {
        this.orderId = orderId;
    }
    getOrder() {
        return this.orderId;
    }
    setDescription(description) {
        this.description = description.toString("base64");
    }
    getDescription() {
        return this.description;
    }
    getLinkToPay(orderId, amount, description) {
        let numberAmount = +amount;
        let hashPrepare = [
            this.shopId,
            orderId,
            numberAmount.toFixed(2),
            this.curr,
            new Buffer(description).toString("base64"),
            this.key
        ];
        //console.log(hashPrepare);
        let hash = crypto.createHash("sha256").update(hashPrepare.join(":")).digest("hex").toUpperCase();
        delete hashPrepare.key;
        return "https://payeer.com/merchant/?m_shop=" + this.shopId + "&m_orderid=" + orderId + "&m_amount=" + amount + "&m_curr=" + this.curr + "&m_desc=" + new Buffer(description).toString("base64") + "&m_sign=" + hash + '&lang=eng';
    }
    handler(params, callback) {
        if (params.m_operation_id && params.m_sign) {
            let arHash = [
                params.m_operation_id,
                params.m_operation_ps,
                params.m_operation_date,
                params.m_operation_pay_date,
                params.m_shop,
                params.m_orderid,
                params.m_amount,
                params.m_curr,
                params.m_desc,
                params.m_status,
                this.key
            ];
            let sign_hash = crypto.createHash("sha256").update(arHash.join(":")).digest("hex").toUpperCase();
            if (params.m_sign == sign_hash && params.m_status == "success") {
                return callback(null, params);
            } else {
                return callback(new Error("Not valid data"), params);
            }
        } else {
            return callback(new Error("Not valid data"), params);
        }
    }
}